module.exports = __webpack_public_path__ + "static/memory_icon-47d8ae6dfa011c5b83ee7c11e4264cde.svg";